import { Close, FilterList } from '@material-ui/icons';
import { Button, Grid } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import * as React from 'react';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';

import { useWebhookHistoryContext } from './context';
import useStyles from '../styles';

enum HistoryStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export const FilterWebhookHistory = () => {
  const classes = useStyles();

  const { productId } = useWebhookHistoryContext();
  const { resetForm, submitForm } = useFormikContext();

  const handleResetForm = () => {
    resetForm();
    submitForm();
  };

  const shouldDisableSelectProduct = productId !== -1;

  return (
    <Grid container spacing={3} alignItems='flex-end'>
      <Grid xs={12} item md={4}>
        <Field label='Data de envio' id='date' name='date' fullWidth component={DateRangePickerFormField} />
      </Grid>

      <Grid item xs={12} md={4}>
        <Field
          id='webhook-historic-product'
          name='product_id'
          label='Produtos'
          disabled={shouldDisableSelectProduct}
          fullWidth
          component={SelectProduct}
          endpoint='reports/filter-all-products'
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Field
          id='webhook-historic-customer'
          name='customer'
          label='Comprador'
          placeholder='Pesquise por nome ou email'
          fullWidth
          component={TextFormField}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <Field
          id='entityId'
          name='entityId'
          component={TextFormField}
          fullWidth
          label='Fatura/Contrato'
          type='tel'
          placeholder='Pesquise por fatura ou contrato'
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <Field
          id='webhook-historic-status'
          name='status'
          label='Status'
          fullWidth
          component={SelectFormField}
          multiple
          options={[
            { label: 'Enviado', value: HistoryStatus.SUCCESS },
            { label: 'Retornou erro', value: HistoryStatus.FAILED },
            { label: 'Pendente', value: HistoryStatus.PENDING },
          ]}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <div className={classes.filterButtonsWrapper}>
          <Button variant='text' onClick={handleResetForm} startIcon={<Close />}>
            Limpar filtros
          </Button>
          <Button variant='contained' color='primary' type='submit' startIcon={<FilterList />}>
            Filtrar
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};
